import React from 'react';
import './Checkbox.css';

/**
 * Checkbox Component
 * Standardized checkbox input
 * 
 * @param {string} label - Checkbox label
 * @param {boolean} checked - Checked state
 * @param {function} onChange - Change handler: (checked: boolean) => void
 * @param {boolean} disabled - Disabled state
 * @param {boolean} required - Required field indicator
 * @param {string} helperText - Helper text below checkbox
 * @param {string} className - Additional CSS classes
 */
const Checkbox = ({
  label,
  checked = false,
  onChange,
  disabled = false,
  required = false,
  helperText,
  className = ''
}) => {
  const handleChange = (e) => {
    if (onChange) {
      onChange(e.target.checked);
    }
  };

  const checkboxId = `checkbox-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <div className={`checkbox-container ${className}`.trim()}>
      <label htmlFor={checkboxId} className="checkbox-label">
        <input
          type="checkbox"
          id={checkboxId}
          checked={checked}
          onChange={handleChange}
          disabled={disabled}
          required={required}
          className="checkbox-input"
          aria-required={required}
          aria-describedby={helperText ? `${checkboxId}-helper` : undefined}
        />
        <span className="checkbox-custom"></span>
        {label && (
          <span className="checkbox-text">
            {label}
            {required && <span className="checkbox-required">*</span>}
          </span>
        )}
      </label>
      {helperText && (
        <span id={`${checkboxId}-helper`} className="checkbox-helper">
          {helperText}
        </span>
      )}
    </div>
  );
};

export default Checkbox;

